import { createFileRoute } from '@tanstack/react-router'
import { ChecklistTemplateEditor } from '@/components/ChecklistTemplateEditor'

export const Route = createFileRoute(
  '/_auth/operations/checklisttemplates/edit/$checklistId'
)({
  component: EditTemplateRoute,
})

function EditTemplateRoute() {
  const { checklistId } = Route.useParams()

  return <ChecklistTemplateEditor mode="edit" templateId={checklistId} />
}
